export default {
  title: 'SEO',
  subtitle:
    'Tilpas titlen og beskrivelsen, der vises i Google-søgeresultater og sociale forhåndsvisninger. Lad feltet stå tomt for at bruge standardværdierne.',
  fields: {
    title: {
      label: 'Sidetitel',
      placeholder: 'f.eks. Forza Napoli – autentisk napolitansk pizza i München',
      help: 'Vises som overskrift i Google-resultater og på browserfaner. Op til 255 tegn; sigt efter 50–60 for den bedste forhåndsvisning.',
    },
    description: {
      label: 'Metabeskrivelse',
      placeholder: 'Kort beskrivelse af din restaurant, der vises under titlen i søgeresultater.',
      help: 'Op til 500 tegn; Google viser typisk 150–160. Fremhæv, hvad der gør din restaurant unik.',
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    saved: 'SEO-indstillinger gemt',
    failed: 'SEO-indstillinger kunne ikke gemmes',
  },
};
